class Enquiry {
  constructor(data = {}) {
    // Properly map _id to id for MongoDB compatibility
    this.id = data.id || data._id || null;
    this._id = data._id || data.id || null;
    this.enquiryId = data.enquiryId || `ENQ${Date.now()}`;
    this.customerName = data.customerName || '';
    this.email = data.email || '';
    this.phone = data.phone || '';
    this.company = data.company || '';
    this.subject = data.subject || '';
    this.message = data.message || '';
    this.enquiryType = data.enquiryType || 'General';
    this.source = data.source || 'Website';
    this.status = data.status || 'Pending';
    this.priority = data.priority || 'Medium';
    this.assignedTo = data.assignedTo || null;
    this.estimatedValue = data.estimatedValue || 0;
    this.followUpDate = data.followUpDate || null;
    this.lastFollowUpDate = data.lastFollowUpDate || null;
    this.notes = data.notes || '';
    this.tags = data.tags || [];
    this.convertedToLead = data.convertedToLead || false;
    this.convertedLeadId = data.convertedLeadId || null;
    this.responseTime = data.responseTime || 0;
    this.createdAt = data.createdAt || new Date().toISOString();
    this.updatedAt = data.updatedAt || new Date().toISOString();
  }

  getStatusColor() {
    const colors = {
      'Pending': '#f59e0b', 'In Progress': '#3b82f6', 'Follow-up': '#8b5cf6',
      'Converted': '#10b981', 'Closed': '#6b7280', 'Rejected': '#ef4444'
    };
    return colors[this.status] || '#6b7280';
  }

  getPriorityColor() {
    const colors = { 'High': '#ef4444', 'Medium': '#f59e0b', 'Low': '#3b82f6' };
    return colors[this.priority] || '#6b7280';
  }

  getSourceColor() {
    const colors = {
      'Website': '#3b82f6', 'Email': '#8b5cf6', 'Phone': '#10b981',
      'Social Media': '#ec4899', 'Referral': '#f59e0b', 'Walk-in': '#6b7280'
    };
    return colors[this.source] || '#6b7280';
  }

  needsFollowUp() {
    if (!this.followUpDate) return false;
    return new Date(this.followUpDate) <= new Date() && !['Converted', 'Closed'].includes(this.status);
  }

  getDaysPending() {
    const diffTime = Math.abs(new Date() - new Date(this.createdAt));
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }

  isHighPriority() {
    return this.priority === 'High' || this.getDaysPending() > 7;
  }

  validate() {
    const errors = [];
    if (!this.customerName?.trim()) errors.push('Customer name is required');
    if (!this.email?.trim()) errors.push('Email is required');
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) errors.push('Email is invalid');
    if (!this.phone?.trim()) errors.push('Phone is required');
    else if (!/^[0-9]{10}$/.test(this.phone.replace(/\D/g, ''))) errors.push('Phone must be 10 digits');
    if (!this.subject?.trim()) errors.push('Subject is required');
    if (!this.message?.trim()) errors.push('Message is required');
    if (this.estimatedValue < 0) errors.push('Estimated value cannot be negative');
    return { isValid: errors.length === 0, errors };
  }

  toJSON() { 
    const json = { ...this };
    // Keep both id and _id for compatibility
    return json;
  }
  
  static fromJSON(json) { 
    return new Enquiry(json); 
  }
}

export default Enquiry;